import colors from 'styles/colors'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 86,
    paddingBottom: 100
  },
  confirmation: {
    color: colors.confidentYellow,
    fontFamily: 'Barlow',
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '28px',
    textAlign: 'center',
    marginTop: '24px',
    marginBottom: '51px',
    width: '30%'
  }
}

export default styles
